import { Component, OnInit } from '@angular/core';
import {Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Output} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {Property} from '../../../services/home-estimator.service';

@Component({
  selector: 'app-home-estimator-dialog',
  templateUrl: './home-estimator-dialog.component.html',
  styleUrls: ['./home-estimator-dialog.component.scss']
})
export class HomeEstimatorDialogComponent implements OnInit {
  @Input() homeEstimatorForm: FormGroup;
  @Input() suggestions: Array<Property>;
  @Input() hasError: boolean = false;
  @Input() standalone: boolean = false;
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSuggestionClick: EventEmitter<Property> = new EventEmitter<Property>();
  @Output() onSuggestionsClose: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }
}
